export const defaultNav={
    ENG:"welcome",
    GER:"willkommen"
}
